/** Shared inert, UTF-8/semicolon export for source-derived offer data. */
export function offerCsvCell(value: unknown): string {
  let text = value == null ? "" : String(value);
  if (/^[\s]*[=+\-@]/.test(text) || /^[\t\r\n]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}

export function offerCsv(rows: unknown[][]): string {
  return "\uFEFF" + rows.map(row => row.map(offerCsvCell).join(";")).join("\r\n");
}

export function downloadOfferCsv(contents: string, filename: string): void {
  const url = URL.createObjectURL(new Blob([contents], { type: "text/csv;charset=utf-8" }));
  const anchor = document.createElement("a");
  anchor.href = url; anchor.download = filename; anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
